import React from 'react'
import Assets from 'app/configs/assetConfigs'
import { IconText } from 'app/components/icons'
import { PollTypeIcon } from 'app/components/icons'
import {
  TYPE_GENERAL,
  TYPE_EVENT,
  TYPE_POLL,
  TYPE_VOUCHER,
} from 'app/constants/messageType'

export const GENERAL_MENU = 'generalMenu'
export const GROUP_MENU = 'groupMenu'

export const NOTI_TYPE_GENERAL = {
  id: TYPE_GENERAL,
  type: GENERAL_MENU,
  disabled: false,
  display: (
    <IconText
      imgSrc={Assets.notiType.info}
      labelId="notiType.general.label"
      additionalTextCls="mt-1"
    />
  ),
}

export const NOTI_TYPE_EVENT = {
  id: TYPE_EVENT,
  type: GENERAL_MENU,
  disabled: false,
  display: (
    <IconText imgSrc={Assets.notiType.event} labelId="notiType.event.label" />
  ),
}

export const NOTI_TYPE_NEWS = {
  id: 6,
  type: GENERAL_MENU,
  disabled: true,
  display: (
    <IconText imgSrc={Assets.notiType.news} labelId="notiType.news.label" />
  ),
}

export const NOTI_TYPE_POLL = {
  id: TYPE_POLL,
  type: GENERAL_MENU,
  disabled: false,
  display: (
    <IconText
      icons={<PollTypeIcon fill="#183560" />}
      labelId="notiType.poll.label"
    />
  ),
}

export const NOTI_TYPE_PROMOTIONAL = {
  id: 8,
  type: GENERAL_MENU,
  disabled: true,
  display: (
    <IconText
      imgSrc={Assets.notiType.promotion}
      labelId="notiType.promotion.label"
    />
  ),
}

export const NOTI_TYPE_BOOKING = {
  id: 11,
  type: GENERAL_MENU,
  disabled: true,
  display: (
    <IconText
      imgSrc={Assets.notiType.booking}
      labelId="notiType.booking.label"
    />
  ),
}

export const NOTI_TYPE_DEALS_PROMOTION = {
  id: 'dealsPromotion',
  type: GROUP_MENU,
  display: (
    <IconText
      imgSrc={Assets.notiType.voucher}
      labelId="createNotification.dialog.dealsPromotion.label"
    />
  ),
  subMenu: [
    {
      id: TYPE_VOUCHER,
      disabled: false,
      display: (
        <IconText
          imgSrc={Assets.notiType.voucher}
          labelId="createNotification.dialog.voucher.label"
        />
      ),
    },
    {
      id: 7,
      disabled: true,
      display: (
        <IconText
          imgSrc={Assets.notiType.voucher}
          labelId="createNotification.dialog.coupon.label"
        />
      ),
    },
    {
      id: 5,
      disabled: true,
      display: (
        <IconText
          imgSrc={Assets.notiType.voucher}
          labelId="createNotification.dialog.discount.label"
        />
      ),
    },
  ],
}

export const NOTI_TYPE_RAFFLE = {
  id: 9,
  type: GENERAL_MENU,
  disabled: true,
  display: (
    <IconText imgSrc={Assets.notiType.raffle} labelId="notiType.raffle.label" />
  ),
}

export const typeList = [NOTI_TYPE_GENERAL, NOTI_TYPE_EVENT, NOTI_TYPE_POLL]

export const comingSoon = [
  NOTI_TYPE_BOOKING,
  NOTI_TYPE_NEWS,
  NOTI_TYPE_PROMOTIONAL,
  NOTI_TYPE_DEALS_PROMOTION,
  NOTI_TYPE_RAFFLE,
]
